import {Component, Input} from '@angular/core';
import {NgClass, NgIf} from "@angular/common";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-input-text',
  standalone: true,
  imports: [
    NgClass,
    NgIf,
    ReactiveFormsModule,
    TranslocoDirective
  ],
  templateUrl: './input-text.component.html',
  styleUrl: './input-text.component.scss'
})
export class InputTextComponent {
  @Input() label: string = "";
  @Input() hint: string = "";
  @Input({ required: true }) control!: FormControl;


  protected IsInValid():boolean {
    return this.control.invalid && this.control.touched;
  }
}
